import { create } from 'zustand';

interface ViewModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useViewModalAgent = create<ViewModalStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useViewModalAgent;
